var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.divider)?_c('li',{staticClass:"roy-context-divider"}):_c('li',{class:_vm.classname,on:{"click":_vm.handleClick,"mouseenter":_vm.handleMouseenter,"mouseleave":_vm.handleMouseleave}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }